import { useState, useEffect } from "react";
import * as React from "react";
import { DateTime } from "luxon";
import dayjs from "dayjs";
import { Starttask } from "../../../Slices/timerslice";
import {
  Tabs,
  Row,
  Col,
  Space,
  message,
} from "antd";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { fetchRequestByIdThunk, getAllWorkHistoryByID, submitRefreshPage, updateRequestThunk, updateWorkHistoryThunk } from "../../../Slices/orderSlice";
import { useErrorLogger } from "../../../utils";
import { EmailTrackMails } from "../Outlook/EmailTrackTab";
import RequestForm from "./RequestForm";
import RequestInformation from "./RequestInformation";
import AttachemntsHistory from "./AttachmentsHistory";
import RequestWorkHistory from "./RequestWorkHistory";
import CreateOrder from "./CreateOrder";
import PolicyCheckTab from "./PolicyCheck/PolicyCheckTab";

import { useNavigate, useParams } from "react-router-dom";

import {
  timerHistoryPayloadChange,
  settaskStartTime,
} from "../../../Slices/user";

import { AntdButton } from "../../../blueplanitUtils/InputField";
import { useRecordLock } from "../../../hooks/useRecordLock";
import RecordLockedModal, { ReleaseRequestBanner } from "../../../components/RecordLockedModal";
 
const RequestDetails = () => {
  const { id } = useParams();
  const requestId = useSelector((state) => state.timer.requestId);
  const { logError } = useErrorLogger();
  const dispatch = useDispatch();
  const RequestInfo = useSelector((state) => state?.orders?.singleOrder);
  const [newRequest, setNewRequest] = useState(RequestInfo);
  const [isDisabled, setIsDisabled] = useState(false);
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);

  const {
    isReadOnly: lockIsReadOnly,
    lockedBy,
    lockChecked,
    requestAccess,
    releaseRequested,
    releaseRequestFrom,
    dismissReleaseRequest,
    releaseForRequester,
  } = useRecordLock("requests", id);

  const [viewReadOnly, setViewReadOnly] = useState(false);
  const isReadOnly = lockIsReadOnly && viewReadOnly;

  const [employeeDetails, setEmployeeDetails] = React.useState({});
  const [open, setOpen] = useState(false);
 
  const [activeTab, setActiveTab] = useState("request_details");
 
  const [RequestInfoState, setRequestInfoState] = useState(RequestInfo);
  // Handle tab change
  const onTabChange = (key) => {
    setActiveTab(key);
  };
 
  useEffect(() => {
    if (id) {
      dispatch(fetchRequestByIdThunk(id));
    }
  }, [dispatch, id]);
 
  useEffect(() => {
    if (RequestInfo) {
      const req = RequestInfo;
 
      const initialValues = {
        ...req,
        responseStatus: req?.responseStatus,
        date: parseInt(req?.date),
        startDate: req?.startDate ? parseInt(req?.startDate) : null,
        dueDate: parseInt(req?.dueDate),
        completedDate: parseInt(req?.completedDate),
        Auto: req?.Auto || false,
        MotorCycle: req?.MotorCycle || false,
        Boat: req?.Boat || false,
        DP3: req?.DP3 || false,
        HO3: req?.HO3 || false,
        HO4: req?.HO4 || false,
        HO5: req?.HO5 || false,
        HO6: req?.HO6 || false,
        umbrella: req?.umbrella || false,
        flud: req?.flud || false,
        isOthers: req?.isOthers || false,
        newQuoteInformation:
          req?.newQuoteInformation?.length > 0
            ? req?.newQuoteInformation
            : [{ policy: '', insuranceCarrier: '', eligibility: '', quotedPremium: '', remarks: '' }],
        existingPolicyInformation:
          req?.existingPolicyInformation?.length > 0
            ? req?.existingPolicyInformation
            : [{ currentCarrier: '', propertyType: '', propertyNew: '', policyNumber: '', effectiveDate: null, currentPremium: '' }],
      };
 
      setNewRequest(initialValues);
    }
  }, [RequestInfo]);
 
  const navigate = useNavigate();
 
  const handleStop = async () => {
    const valuesObject = {
      id: Math.random().toString(),
      userId: loginUser?.id,
      title: "",
      description: "",
      clientName: "Blueplanit",
      department: "Operations",
      taskType: "Available",
      startTime: Date.now().toString(),
      endTime: Date.now().toString(),
      requestId: "",
    };
    dispatch(timerHistoryPayloadChange({ data: valuesObject }));
    const updatePayload = {
      userId: loginUser.id,
      emailId: "",
      requestId: "",
      clientName: "Blueplanit",
      processType: "",
      taskType: "Available",
      email: "",
      subject: "",
      body: "",
      startTime: Date.now().toString(),
      endTime: "",
      department: "Operations",
    };
    await dispatch(updateWorkHistoryThunk(updatePayload)).unwrap()
    const payload = {
      department: '',
      requestId: '',
      task: "Available",
      time: Date.now(),
    };
    localStorage.setItem("time", new Date().getTime());
    localStorage.removeItem("department");
    localStorage.removeItem("requestId");
    localStorage.removeItem("task");
    dispatch(settaskStartTime(new Date().getTime()));
    dispatch(Starttask(payload));
 
    dispatch(getAllWorkHistoryByID(RequestInfo?.id));
  };
 
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const cancelHandelar = () => {
    dispatch(submitRefreshPage(false));
    navigate("/request");
  };
 
  const getLocalTimeZone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };
 
  const initialValues = {
    id: RequestInfo?.id,
    from: RequestInfo?.from,
    to: RequestInfo?.to,
    requestId: RequestInfo?.requestId,
    subject: RequestInfo?.subject,
    emailNeeded: RequestInfo?.emailNeeded,
    emailCompleted: RequestInfo?.emailCompleted,
    hold: RequestInfo?.hold,
    date: parseInt(RequestInfo?.date),
    taskComplete: RequestInfo?.taskComplete,
    priority: RequestInfo?.priority,
    Assign: RequestInfo?.Assign,
    request_type: RequestInfo?.request_type,
    instructions: RequestInfo?.instructions,
    fromPending: RequestInfo?.fromPending,
    quoteType: RequestInfo?.quoteType,
    department: RequestInfo?.department,
    insuredName: RequestInfo?.insuredName,
    noofQuotes: RequestInfo?.noofQuotes,
    holderName: RequestInfo?.holderName,
    insuredDelivery: RequestInfo?.insuredDelivery,
    holderDelivery: RequestInfo?.holderDelivery,
    accountManagerDelivery: RequestInfo?.accountManagerDelivery,
    otherDelivery: RequestInfo?.otherDelivery,
    radioValue: RequestInfo?.radioValue,
    Auto: RequestInfo?.Auto || false,
    MotorCycle: RequestInfo?.MotorCycle || false,
    Boat: RequestInfo?.Boat || false,
    DP3: RequestInfo?.DP3 || false,
    HO3: RequestInfo?.HO3 || false,
    HO4: RequestInfo?.HO4 || false,
    HO5: RequestInfo?.HO5 || false,
    HO6: RequestInfo?.HO6 || false,
    umbrella: RequestInfo?.umbrella || false,
    flud: RequestInfo?.flud || false,
    isOthers: RequestInfo?.isOthers || false,
    others: RequestInfo?.others,
    comments: RequestInfo?.comments,
    processType: RequestInfo?.processType,
    assignedTo: RequestInfo?.assignedTo,
    assignTo: RequestInfo?.assignTo,
    startDate: RequestInfo?.startDate ? parseInt(RequestInfo?.startDate) : null,
    dueDate: RequestInfo?.dueDate ? dayjs(parseInt(RequestInfo?.dueDate)) : null,
    completedDate: parseInt(RequestInfo?.completedDate),
    requestStatus: RequestInfo?.requestStatus,
    responseDate: RequestInfo?.responseDate,
    emailSummary: RequestInfo?.emailSummary,
    requestor: RequestInfo?.requestor,
    responseStatus: RequestInfo?.responseStatus,
    sendTo: RequestInfo?.sendTo,
    clientName: RequestInfo?.clientName || RequestInfoState?.clientName,
    newQuoteInformation: (RequestInfo?.newQuoteInformation?.length > 0) ? RequestInfo?.newQuoteInformation : [{
      policy: '',
      insuranceCarrier: '',
      eligibility: '',
      quotedPremium: '',
      remarks: '',
 
    }],
    existingPolicyInformation: (RequestInfo?.existingPolicyInformation?.length > 0) ? RequestInfo?.existingPolicyInformation : [{
      currentCarrier: '',
      propertyType: '',
      propertyNew: '',
      policyNumber: '',
      effectiveDate: null,
      currentPremium: ''
    }]
 
  };
 
  const localToUtc = (localDateTimeStr) => {
    const timeZone = getLocalTimeZone();
    try {
 
      const localDateTime = DateTime.fromJSDate(localDateTimeStr.toDate(), { zone: timeZone });
 
 
      const utcDateTime = localDateTime.toUTC();
      return utcDateTime.toISO();
    } catch (error) {
      console.error(`Error converting local time to UTC: ${error.message}`);
      return null;
    }
  };
 
  const startTimer = () => {
    setIsDisabled(true);
    setTimeout(() => {
      setIsDisabled(false);
    }, 3000);
  };
 
  const submit = async (values) => {
    try {
      const { dueDate: dueDate1, ...restValues } = values;
      const { dueDate: dueDate2, ...restRequest } = newRequest;
 
      const areRestEqual = JSON.stringify(restValues) === JSON.stringify(restRequest);
      const isDueDateEqual = new Date(dueDate1).getTime() === new Date(dueDate2).getTime();
 
      const areAllEqual = areRestEqual && isDueDateEqual;
      if (areAllEqual) {
        startTimer();
        message.error({
          content: "No changes detected. Please update the fields before submitting.",
          duration: 3,
          className: 'custom-toast-center',
        });
        return;
      }
 
      startTimer();
      setNewRequest(values)
 
      const valuesObject = {
        id: RequestInfo?.id,
        emailNeeded: values?.emailNeeded,
        emailCompleted: values?.emailCompleted,
        hold: values?.hold,
        subject: values?.subject,
        from: values.from,
        to: values.to,
        taskComplete: values?.taskComplete,
        priority: values.priority,
        request_type: values.request_type,
        instructions: values.instructions,
        fromPending: values.fromPending,
        quoteType: values.quoteType,
        department: values.department,
        insuredName: values.insuredName,
        noofQuotes: parseInt(values.noofQuotes),
        holderName: values.holderName,
        insuredDelivery: values.insuredDelivery,
        holderDelivery: values.holderDelivery,
        accountManagerDelivery: values.accountManagerDelivery,
        otherDelivery: values.otherDelivery,
        radioValue: values.radioValue,
        Auto: values.Auto,
        MotorCycle: values.MotorCycle,
        Boat: values.Boat,
        DP3: values.DP3,
        HO3: values.HO3,
        HO4: values.HO4,
        HO5: values.HO5,
        HO6: values.HO6,
        umbrella: values.umbrella,
        flud: values.flud,
        isOthers: values.isOthers,
        others: values.others,
        comments: values.comments,
        processType: values.processType,
        assignedTo: values.assignedTo,
        assignTo: values.assignTo,
        startDate: localToUtc(dayjs(values.startDate)) || dayjs(parseInt(RequestInfo.date)),
        dueDate: values.dueDate ? localToUtc(dayjs(values.dueDate)) : null,
        completedDate: dayjs(parseInt(values.completedDate)),
        requestStatus: values.requestStatus,
        responseStatus: values.responseStatus,
        Assign: values.Assign,
        emailSummary: values.emailSummary,
        requestor: values.requestor,
        sendTo: values.sendTo,
        clientName: values.clientName,
        newQuoteInformation: values.newQuoteInformation.map(
          ({ __typename, ...rest }) => rest
        ),
        existingPolicyInformation: values.existingPolicyInformation.map(
          ({ __typename, ...rest }) => rest
        ),
 
      };
      const historyObject = {
        userId: loginUser?.id,
        emailId: RequestInfo.id,
        oldStatus: RequestInfo?.requestStatus || "",
        newStatus: values.requestStatus || "",
        changeTime: Date.now().toString(),
      };
      await dispatch(updateRequestThunk({ valuesObject, historyObject, RequestInfo, loginUser }));
      dispatch(submitRefreshPage(true));
      setRequestInfoState((prev) => ({
        ...prev,
        clientName: values.clientName
      }));
 
      message.success({
        content: "Request updated successfully!",
        duration: 3,
        className: "custom-toast-center",
      });
 
    } catch (error) {
      await logError("RequestDetails", "submit", error.message);
      console.error("Error updating request:", error);
    }
  };
 
  return (
    <>
      {/* Record locked by another user */}
      {lockChecked && lockIsReadOnly && !viewReadOnly && (
        <RecordLockedModal
          lockedBy={lockedBy}
          onViewReadOnly={() => setViewReadOnly(true)}
          onRequestAccess={requestAccess}
          onGoBack={() => navigate("/request")}
        />
      )}

      {/* Banner for lock holder when someone requests access */}
      {releaseRequested && (
        <ReleaseRequestBanner
          requestFrom={releaseRequestFrom}
          onRelease={() => {
            releaseForRequester();
            navigate("/request");
          }}
          onDismiss={dismissReleaseRequest}
        />
      )}

      <div style={{ width: "100%", marginBottom: "5px" }}>
        {/* Read-only banner */}
        {isReadOnly && (
          <div style={{
            background: "#fff7e6", border: "1px solid #ffd591", padding: "8px 16px",
            borderRadius: 6, marginBottom: 8, display: "flex", alignItems: "center", gap: 8,
          }}>
            <span style={{ fontSize: 16 }}>🔒</span>
            <span>
              <strong>Read-Only Mode</strong> — This request is being edited by{" "}
              <strong>{lockedBy?.userName}</strong>. You can view but not modify.
            </span>
          </div>
        )}

        {open && (
          <CreateOrder
            open={open}
            handleClose={handleClose}
            //  handleStart={handleStart}
            RequestInfo={RequestInfo}
            RequestInfoState={RequestInfoState}
            setRequestInfoState={setRequestInfoState}
          />
        )}
 
        <Formik
          onSubmit={(values) => { if (!isReadOnly) submit(values); }}
          initialValues={initialValues}
          enableReinitialize={true}
        >
          {({
            errors,
            handleBlur,
            handleSubmit,
            handleChange,
            touched,
            setFieldValue,
            values,
          }) => {
            const items = [
              {
                key: 'request_details',
                label: 'Request Details',
                children: (
                  <RequestForm
                    initialValues={initialValues}
                    employeeDetails={employeeDetails}
                    setEmployeeDetails={setEmployeeDetails}
                    RequestInfo={RequestInfo}
                    handleChange={handleChange}
                    values={values}
                    errors={errors}
                    touched={touched}
                    handleBlur={handleBlur}
                    setFieldValue={setFieldValue}
                  />
                ),
              },
              {
                key: 'attachment_history',
                label: 'Attachments History',
                children: (
                  <AttachemntsHistory
                    initialValues={initialValues}
                    employeeDetails={employeeDetails}
                    setEmployeeDetails={setEmployeeDetails}
                    RequestInfo={RequestInfo}
                    handleChange={handleChange}
                    values={values}
                  />
                ),
              },
              {
                key: 'work_history',
                label: 'Work History',
                children: (
                  <RequestWorkHistory
                    initialValues={initialValues}
                    employeeDetails={employeeDetails}
                    setEmployeeDetails={setEmployeeDetails}
                    RequestInfo={RequestInfo}
                    handleChange={handleChange}
                    values={values}
                  />
                ),
              },
              ...(RequestInfo?.processType === 'Policy Checking' ? [{
                key: 'policy_check',
                label: 'Policy Check',
                children: (
                  <PolicyCheckTab
                    requestId={id}
                    RequestInfo={RequestInfo}
                  />
                ),
              }] : []),
            ];
 
            return (
              <div style={isReadOnly ? { pointerEvents: "none", opacity: 0.7 } : {}}>
                <Row gutter={16} style={{ marginBottom: "7px" }}>
                  <Col span={24} style={{ marginTop: 16 }}>
                    <Space>
                      {!isReadOnly && (
                        <AntdButton
                          label="Save"
                          color="primary"
                          variant="solid"
                          htmlType="submit"
                          disabled={isDisabled}
                          onClick={handleSubmit}
                        />
                      )}
                      <AntdButton
                        color="danger"
                        variant="solid"
                        onClick={cancelHandelar}
                        label="Close"
                        style={isReadOnly ? { pointerEvents: "auto" } : {}}
                      />
                    </Space>
                    <Space style={{ float: "right" }}>
                      {requestId === RequestInfo?.requestId ? (
                        <AntdButton
                          label="Stop"
                          color="danger"
                          variant="solid"
                          onClick={handleStop}
                        />
                      ) : (
                        <AntdButton
                          label="Start"
                          color="primary"
                          variant="solid"
                          style={{ float: "right" }}
                          onClick={handleOpen}
                        />
                      )}
                    </Space>
                  </Col>
                </Row>
 
                <RequestInformation
                  initialValues={initialValues}
                  employeeDetails={employeeDetails}
                  setEmployeeDetails={setEmployeeDetails}
                  RequestInfo={RequestInfo}
                  handleChange={handleChange}
                  values={values}
                  setFieldValue={setFieldValue}
                  errors={errors}
                  touched={touched}
                />
 
                <Tabs
                  activeKey={activeTab}
                  onChange={onTabChange}
                  type="card"
                  items={items}
                />
              </div>
            );
          }}
        </Formik>
 
      </div>
    </>
  );
};
 
export default RequestDetails;
 